import { GetRequest, PutRequest } from "../service"

const ControllerName = "Request"

export const GetMedicalRequest = (link) =>
    GetRequest(ControllerName + link)

export const GetMedicalRequestDetails = (id) =>
    GetRequest(`${ControllerName}/get-details/${id}`)

export const CreateQuotation = (id, data) =>
    PutRequest(`${ControllerName}/create-quotation/${id}`, data)

export const GetAdmissionDetails = (id) =>
    GetRequest(`${ControllerName}/get-admission-details/${id}`)

export const CreatePostService = (data) =>
    PutRequest(`${ControllerName}/create-post-service`, data)

export const SubmitAdmission = (id) =>
    PutRequest(`${ControllerName}/start-quotation/${id}`)

export const DeclineQuotation = (id) =>
    PutRequest(`${ControllerName}/declined-quotation/${id}`)

export const DischargeQuotation = (id) =>
    PutRequest(`${ControllerName}/discharge-quotation/${id}`)
